<template>
  <div class="flex grow flex-col gap-y-5 overflow-y-auto bg-grey-900 px-4">
    <div class="flex h-14 shrink-0 items-center">
      <NuxtLink to="/" @click="emit('close')">
        <img
          class="h-7 w-auto"
          src="/assets/icons/layout/logo-white.png"
          alt="Benchmark Mineral Intelligence"
        />
      </NuxtLink>
    </div>

    <MobileMainNav :navigation="topbarNavigation" @close="emit('close')" />

    <nav class="flex flex-1 flex-col gap-y-1 pt-3 text-white">
      <template v-for="item in navigation" :key="item.name">
        <NuxtLink
          v-if="!item.children"
          :to="item.href"
          :external="isExternalLink(item.href)"
          :target="isExternalLink(item.href) ? '_blank' : undefined"
          :class="[
            item.current
              ? 'bg-p-500 font-semibold text-grey-900'
              : 'hover:bg-p-200 hover:text-grey-900',
            'group flex cursor-pointer gap-x-3 rounded-md px-3 py-1 text-sm/6 font-medium',
          ]"
          @click="emit('close')"
        >
          {{ item.name }}
        </NuxtLink>

        <Disclosure
          v-else
          v-slot="{ open }"
          as="div"
          :default-open="childrenHasCurrent(item.children)"
        >
          <DisclosureButton
            :class="[
              currentClasses(item.current),
              'group flex w-full cursor-pointer items-center gap-x-3 rounded-md px-3 py-1 text-left text-sm/6 font-medium text-white',
            ]"
          >
            {{ item.name }}
            <ChevronRightIcon
              :class="[
                currentClasses(item.current),
                open ? 'rotate-90' : 'group-hover:text-grey-900',
                'ml-auto size-5 shrink-0 text-white transition-transform duration-200',
              ]"
              aria-hidden="true"
            />
          </DisclosureButton>
          <DisclosurePanel as="ul" class="mt-1 flex flex-col gap-1">
            <template v-for="subItem in item.children" :key="subItem.name">
              <DisclosureButton
                :as="NuxtLink"
                :to="subItem.href"
                :external="isExternalLink(subItem.href)"
                :class="[
                  subCurrentClasses(subItem.current),
                  'text-gray-100 block rounded-md py-1 pl-6 pr-2 text-xs/6',
                ]"
                @click="emit('close')"
              >
                {{ subItem.name }}
              </DisclosureButton>
            </template>
          </DisclosurePanel>
        </Disclosure>
      </template>
    </nav>
  </div>
</template>

<script setup lang="ts">
import { Disclosure, DisclosureButton, DisclosurePanel } from '@headlessui/vue'
import { ChevronRightIcon } from '@heroicons/vue/20/solid'
import MobileMainNav from '~/components/layout/MobileMainNav.vue'
import type {
  TNavigationItem,
  TTopbarNavigationItem,
} from '~/src/types/navigation'

const NuxtLink = resolveComponent('NuxtLink')

defineProps<{
  navigation: TNavigationItem[]
  topbarNavigation: TTopbarNavigationItem[]
}>()

const emit = defineEmits<{
  close: []
}>()

const childrenHasCurrent = (children: TNavigationItem[]) =>
  children.some((child) => child.current)

const isExternalLink = (href: string) =>
  href.startsWith('http') || href.startsWith('//')

const currentClasses = (isCurrent: boolean) => {
  if (isCurrent) return 'bg-p-500 font-semibold !text-grey-900'
  return 'hover:bg-p-200 hover:text-grey-900'
}

const subCurrentClasses = (isCurrent: boolean) => {
  if (isCurrent) return 'bg-p-200 font-semibold !text-grey-900'
  return 'hover:bg-p-200 hover:text-grey-900'
}
</script>
